<template>
  <section class="head-image w-100 bg-cl-th-accent cl-white">
    <div v-if="typeof currentStore !== 'undefined'"
         class="container head-image-bg w-100 h-100 cl-black"
         :style="{ 'background-image': 'url(' + partnerBanner + ')' }"
    >
      <div class="head-image-content w-100 flex center-xs pt10 pb10" :class="{ 'foot-padding': currentPartner && currentPartner.display_mode === 'food' }">
        <div class="image-wrapper flex middle-xs" :class="{'mobile-small-text': smallNamePartner}">
          <img :src="partnerLogo" :alt="currentStore.title" :width="partnerLogoSize.width" :height="partnerLogoSize.height" loading="eager" fetchpriority="high">
        </div>
        <div class="store-name col-md-5 col-xs-5 flex" :class="{'small-store-name': smallNamePartner}">
          <h1 class="name-partner" :class="{ 'uppercase': currentStore.code === 'novus', 'smallNamePartner': smallNamePartner }">
            {{ currentStore.title }}
          </h1>
          <div class="locationLink relative" @click="processPartnerLink('/schedule')">
            {{ $t('Shipping') }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script async>
import config from 'config';
import { mapGetters } from 'vuex';
import { s3Path } from '@vue-storefront/core/helpers';

export default {
  data () {
    return {
      loadModal: false,
      smallNamePartner: false
    }
  },
  computed: {
    ...mapGetters({
      currentImage: 'promoted/getHeadImage',
      currentStore: 'partners/getCurrentPartner',
      locationsInfo: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),

    partnerLogo () {
      return s3Path(this.currentStore.logo_path, config.images.partner_logo.width, config.images.partner_logo.height)
    },
    partnerLogoSize () {
      return config.images.partner_logo
    },
    partnerBanner () {
      return s3Path(this.currentStore.banner)
    }
  },
  mounted () {
    if (this.currentStore) {
      let namePartner = this.currentStore.title.split(' ');
      if (namePartner.length > 1) {
        namePartner.map(text => {
          if (text.length >= 13) {
            this.smallNamePartner = true
          }
        })
      } else {
        if (namePartner[0].length >= 13) {
          this.smallNamePartner = true
        }
      }
    }
  },
  methods: {
    showAboutModal () {
      this.loadModal = true
      this.$bus.$emit('modal-show', 'modal-about')
    },
    getServiceText (service, store) {
      return (service.code === 'pickup' || service.code === 'minimal_order_amount')
        ? service.title
        : `${service.title}: ${store.working_hours}`
    },
    processPartnerLink (page) {
      this.$router.push({ path: `${this.currentStore.route + page}` })
    }
  },
  metaInfo () {
    if (this.partnerLogo) {
      return {
        link: [
          { rel: 'preload', as: 'image', href: this.partnerLogo }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .small-store-name {
    @media (max-width: 400px) {
      margin-left: 10px!important;
    }
  }
  .mobile-small-text{
    @media (max-width: 400px) {
      margin-left: 10%!important;
    }
    @media (max-width: 320px) {
      margin-left: 0!important;
    }
  }
  .smallNamePartner{
    @media (max-width: 400px) {
      font-size: 18px!important;
    }
  }
  .foot-padding{
    padding-top: 80px !important;
  }
  .head-image {
    position: relative;
    .head-image-bg{
      @media (max-width: 500px) {
        width: 100%;
        padding-left:0 !important;
        padding-right:0 !important;
      }
    }
    .image-wrapper{
      width: 110px !important;
      height: 110px !important;
      margin-bottom: 10px;
      border-radius: 10%;
      margin-left: 20%;
      -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
      background-color: white;
      padding: 5px;
      @media (max-width: 425px) {
        width: 90px !important;
        height: 90px !important;
        margin-left: 12%;
      }
      @media (max-width: 320px) {
        margin-left: 6%;
      }
      img{
        width: 100%;
        height: auto;
        max-width: 80px;
        margin: 0 auto;
        @media (max-width: 425px) {
          max-width: 95px;
          max-height: 95px;
        }
      }
    }

    .head-image-content {
      display: flex;
      align-items: center;
      padding-bottom: 50px;
      padding-top: 15px;
      background: #0000006b;
      width: 470px;
      margin: 0 auto;
      a.store-title{
        color: #fff;
      }
      @media (max-width: 500px) {
        width: 100%;
      }
    }
  }

  .store-name {
    margin: 8px 0;
    display: flex;
    flex-direction: column;
    color: #ffffff;
    text-align: left;
    margin-left: 20px;
    margin-top: 0;
    margin-bottom: 15px;
    .name-partner{
      font-size: 24px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.15px;
      margin: 0px 0px;
      @media (max-width: 320px) {
        font-size: 20px;
      }
    }
    .locationLink{
      color: #ffffff;
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;
    }
    .links{
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.09px;
      margin-bottom: 10px;
      text-decoration: underline;
      text-underline-offset: 2px;

      @media (max-width: 320px) {
        width: 57%;
        font-size: 12px;
      }
    }
  }

  .info-store{
    line-height: 12px;
    padding: 3px;
    font-size: 12px;
    font-weight: bold;
    margin: 0 4px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    border-radius: 2px;
    background-color: white;
    border: 1px solid #f7a700;
    color: #f7a700 ;
  }

  .container {
    background-size: cover;
    background-position: bottom center;
    background-repeat: no-repeat;
  }

  @media (max-width: 75em) {
    .store-title {
      font-size: 20px;
    }
  }
  @media (max-width: 64em) {
    .store-title {
      font-size: 18px;
    }
  }
</style>
